export default __webpack_public_path__ + "static/media/person_3@2x.0a50a6c8.png";